export const VALIDATION_MESSAGES = {
  DOB_FORMAT: 'Enter only month and day of birth as MM/DD',
  FIRST_NAME_REQUIRED: 'First name is required',
  LAST_NAME_REQUIRED: 'Last name is required',
  NPI_FORMAT: 'NPI should be 10 digits',
};
